import CookiesJS from 'cookies-js';

export function initTrainings($, apiClient) {
    function extractArrayItems(field) {
        const items = [];
        $(`#${field} .array-item .array-item-value`).each(function () {
            items.push($(this).val());
        });
        return items;
    }

    $('form.training-form .action__entity-save').on('click', async function () {
        try {
            const _id = $(this).attr('data-object-id');
            const exercises = [];
            $('#exercises .array-item').each(function () {
                const exercise = {
                    exerciseId: $(this).find('select.exercises-exerciseId').val(),
                    weekDays: $(this).find('select.exercises-weekDays').val(),
                };
                exercise.time = $(this).find('.exercises-time').val();
                exercise.reps = $(this).find('.exercises-reps').val();
                exercise.sets = $(this).find('.exercises-sets').val();
                exercise.rest = $(this).find('.exercises-rest').val();
                exercises.push(exercise);
            });
            const training = {
                title: $('#title').val(),
                description: $('#description').val(),
                exercises,
                tags: extractArrayItems('tags'),
                levels: $('#levels').val(),
                goals: $('#goals').val(),
                equipment: $('#equipment').val(),
                contraindications: $('#contraindications').val(),
                deleted: !!$('#deleted').prop('checked'),
            };
            if (!_id) {
                const result = await apiClient.create('/trainings', training, CookiesJS.get('auth_token'));
                console.log(result);
                document.location.href=`/trainings/edit/${result._id}`;
            } else {
                const result = await apiClient.updateOne('/trainings', _id, training, CookiesJS.get('auth_token'));
                console.log(result);
                alert('Сохранено');
                location.reload();
            }
        } catch (e) {
            console.warn(e);
            if (e.response
                && e.response.data
                && e.response.data.errors
                && e.response.data.errors[0]
                && e.response.data.errors[0].msg
            ) {
                alert(`${e.response.data.errors[0].msg}: ${e.response.data.errors[0].param}`);
            } else {
                alert(e);
            }
        }
    });
}
